<template>
  <div>
     <loader v-if="showLoader"></loader>
      <vuetable
        class="siel-table"
        v-bind="$attrs"
        ref="vuetable"
        :http-fetch="fetchFrom"
        :http-options="fetchFromOptions"
        :css="css.table"
        pagination-path="meta"
        @vuetable:pagination-data="onPaginationData"
        @vuetable:loading="onLoading"
        @vuetable:load-success="onLoadSuccess"
        @vuetable:loaded="onLoaded"
      >
        <template
          v-for="(_, name) in $scopedSlots"
          :slot="name"
          slot-scope="slotData"
        >
          <slot
            :name="name"
            v-bind="slotData"
          />
        </template>
      </vuetable>
    <vuetable-pagination
      class="siel-pagination"
      ref="pagination"
      :css="css.pagination"
      @vuetable-pagination:change-page="onChangePage"
    />
  </div>
</template>

<script>
  import Vuetable from 'vuetable-2'
  import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
  import Loader from './Loader'

  export default {
    name: 'DataTable',
    components: { Loader, Vuetable, VuetablePagination },
    props: {
      fetchFrom: {
        default: null,
      },
      fetchFromOptions: {
        default: {},
      },
    },
    data: () => ({
      showLoader: false,
    }),
    computed: {
      css () {
        return {
          table: {
            tableWrapper: 'v-data-table',
            tableClass: 'table',
            ascendingIcon: 'fa fa-sort-amount-asc ',
            descendingIcon: 'fa fa-sort-amount-desc ',
            sortableIcon: 'fa fa-sort',
          },
          pagination: {
            wrapperClass: 'ui right floated pagination menu',
            activeClass: 'active large',
            disabledClass: 'disabled',
            pageClass: 'item',
            linkClass: 'icon item',
            paginationClass: 'ui bottom attached segment grid',
            paginationInfoClass: 'left floated left aligned six wide column',
            dropdownClass: 'ui search dropdown',
            icons: {
              first: '',
              prev: '',
              next: '',
              last: '',
            },
          },
        }
      },

    },
    methods: {
      onLoading () {
        this.showLoader = true
      },
      onLoadSuccess () {
        this.showLoader = false
      },
      onLoaded () {
        this.$emit('loaded')
      },
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      refresh () {
        this.$refs.vuetable.refresh()
      },
      getData () {
        return this.$refs.vuetable.tableData
      },
    },
  }
</script>

<style>

.siel-table {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  border-collapse: collapse;
}

.siel-table thead th{
  text-align: left;
  font-size: 1em;
  padding: 5px;
}
.siel-table thead th{
  background-color: #e1e1e1;
}

.siel-table tbody td {
  padding: 5px;
}

.siel-table tbody tr:nth-child(even) {
  background: #EEEEEE;
}

.siel-table tbody tr:nth-child(odd) {
  background: #FFF
}

.siel-pagination {
  text-align: center;
  font-size: 1.2em;
}

.siel-pagination a.item{
  padding: 2px 5px 2px 5px;
  margin-left: 2px;
}

.siel-pagination a.item.active{
  border-radius: 2px;
  font-weight: bolder;
  background-color: #2E76BF;
  color: white;
}
</style>
